import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import HomeV2 from './views/v2/HomeV2.vue'
import Records from './views/v2/Records.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/v2',
      name: 'homeV2',
      component: HomeV2
    },
    {
      path: '/records',
      name: 'records',
      component: Records
    }
  ]
})
